module.exports = __webpack_public_path__ + "img/john-harald-knutsson-p.749b3a12.jpg";